import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';

import { QuickBooksSyncedField } from '../../utils/quickbooks-synced-fields';

interface UpdateQuickBooksClientModalProps {
  open: boolean;
  changedFields: QuickBooksSyncedField[];
  onConfirm: () => void;
  onClose: () => void;
}

export function UpdateQuickBooksClientModal({
  open,
  changedFields,
  onConfirm,
  onClose,
}: UpdateQuickBooksClientModalProps) {
  const { t } = useTranslation(['authenticated.clients', 'common']);

  return (
    <ConfirmationModal
      open={open}
      onOpen={() => {}}
      onClose={onClose}
      title={t('details.quickBooksSync.confirmModal.title')}
      message={t('details.quickBooksSync.confirmModal.message')}
      confirmText={t('details.quickBooksSync.confirmModal.confirm')}
      confirmVariant="default"
      onConfirm={closeModal => {
        onConfirm();
        closeModal();
      }}
    >
      <div className="space-y-1 text-sm">
        <p className="font-medium">{t('details.quickBooksSync.confirmModal.changedFields')}</p>
        <ul className="list-inside list-disc text-muted-foreground">
          {changedFields.map(field => (
            <li key={field}>{t(`details.quickBooksSync.fields.${field}`)}</li>
          ))}
        </ul>
        {changedFields.includes('billingAddress') && !changedFields.includes('shippingAddress') && (
          <p className="pt-2 text-muted-foreground">
            {t('details.quickBooksSync.confirmModal.linkedShippingNote')}
          </p>
        )}
      </div>
    </ConfirmationModal>
  );
}
